import { AppSidebar } from "@/components/app-sidebar"
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"

export function Page({
  headerSlot,
  tabSlot,
  children,
}: {
  headerSlot?: React.ReactNode
  tabSlot?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <>
      <AppSidebar />
      <SidebarInset>
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col">
            <div className="flex items-center min-h-16 gap-2 border-b w-full px-5">
              <div className="flex items-center gap-2 pl-3 pr-4 shrink-0">
                <SidebarTrigger />
              </div>
              <header className="flex-1 flex items-center py-4">{headerSlot}</header>
            </div>
            {tabSlot}
            <div className="p-6">{children}</div>
          </div>
        </div>
      </SidebarInset>
    </>
  )
}
